<template>
	<section class="v-modal">
		<header v-if="header" class="v-modal__header">
			<div>
				<slot name="header"/>
			</div>
			<div class="v-modal__header__actions">
				<div>
					<slot name="back"/>
				</div>
				<ul class="actions actions--icons">
					<slot name="actions"/>
					<li v-if="$vmodal.options.isDismisable">
						<button class="button--icon icon--close" @click.prevent="$vmodal.close()">Close</button>
					</li>
				</ul>
			</div>
		</header>
		<div ref="content" class="v-modal__content">
			<slot/>
		</div>
		<footer class="v-modal__footer">
			<slot name="footer"/>
		</footer>
	</section>
</template>
<script>
export default {
	data() {
		return {
			observer: null,
		};
	},

	props: {
		header: {
			required: false,
			default() {
				return true;
			},
		},
	},

	mounted() {
		const observer = new MutationObserver((mutationsList, observer) => {
			let tabs = _.filter(mutationsList, (node) => {
				return node.target?.__vue__?.$options?._componentTag === "v-tab";
			});
			if (!tabs.length) {
				return;
			}
			this.refs.content.scrollTo(0, 0);
		});
		observer.observe(this.refs.content, {
			childList: true,
			subtree: true,
			attributes: true,
		});
		this.observer = observer;
	},

	beforeDestroy() {
		this.observer?.disconnect();
		this.observer = null;
	},
};
</script>
